export class UserModel {
    id:number;
    name:string;
    username: string;
    password: string;
    userType: string;
    isEnable: boolean;
    adminInstitutionId:number;
}